import { UnleashClient } from 'unleash-proxy-client'
import { featureFlagConfig as FEATURE_FLAG_CONFIG } from 'config'
import { USER_KEY } from 'constants/localStorage'

var _unleashClient = null

// Return the singleton UnleashClient instance, used to access GitLab feature flags
// (within a React component, you should use useFlag() instead)
const unleashClient = () => {
  if (!_unleashClient) {
    let storedUserId
    try {
      const raw = localStorage.getItem(USER_KEY)
      storedUserId = raw ? JSON.parse(raw)?.id : undefined
    } catch {
      // ignore malformed storage
    }
    _unleashClient = new UnleashClient({
      ...FEATURE_FLAG_CONFIG,
      ...(storedUserId && { context: { userId: String(storedUserId) } }),
    })
  }

  return _unleashClient
}

export function updateUnleashUserId(userId) {
  if (_unleashClient && userId) {
    _unleashClient.updateContext({ userId: String(userId) })
  }
}

export default unleashClient
